export default "__VITE_ASSET__DeQyV2zD__"